import { Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./DefaultSubscribeForm.module.scss";

const RequiredFields: React.FC = () => {
  return (
    <div className={styles.requiredFieldsLabel}>
      *<Trans>Required fields</Trans>
    </div>
  );
};

export default RequiredFields;
